export { default } from './useCopyClipboard';
